/**
 * Human-readable labels for aggregate types used in traffic analysis
 */
export const AGGREGATE_LABELS = {
  p95th_bits_per_sec: '95th Percentile Bits/sec',
  avg_bits_per_sec: 'Average Bits/sec',
  max_bits_per_sec: 'Max Bits/sec',
  sum_bits_per_sec: 'Total Bits/sec',
  unique_src_ip: 'Unique Source IPs',
  unique_dst_ip: 'Unique Destination IPs',
  sum_packets: 'Total Packets',
  sum_bytes: 'Total Bytes'
};

/**
 * Get human-readable label for an aggregate type
 * @param {string} aggregateType - The aggregate type key
 * @returns {string} Human-readable label or the original type if not found
 */
export function getAggregateLabel(aggregateType) {
  return AGGREGATE_LABELS[aggregateType] || aggregateType;
}
